import { render, staticRenderFns } from "./EditarProcedimentoOrigemAtaRegistroPreco.vue?vue&type=template&id=0ecf3d97&scoped=true"
import script from "./EditarProcedimentoOrigemAtaRegistroPreco.vue?vue&type=script&lang=ts"
export * from "./EditarProcedimentoOrigemAtaRegistroPreco.vue?vue&type=script&lang=ts"
import style0 from "./EditarProcedimentoOrigemAtaRegistroPreco.vue?vue&type=style&index=0&id=0ecf3d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf3d97",
  null
  
)

export default component.exports